import {Brick, registerBrick} from 'olympe';
import {TimeoutMap} from '@olympeio/core';

/**
 * This brick creates a TimeoutMap
 */
export default class CreateTimeoutMap extends Brick {
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {number} timeout
     * @param {number} refreshRate
     * @param {function()} forwardEvent
     * @param {function(TimeoutMap)} setTimeoutMap
     */
    update($, [timeout, refreshRate], [forwardEvent, setTimeoutMap]) {
        setTimeoutMap(new TimeoutMap(timeout, refreshRate));
        forwardEvent();
    }
}

registerBrick('0192e3222160e718ef17', CreateTimeoutMap);
